var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyTestX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u274C",
    clipPath: "url(#clip0_516_1944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.1877 14.1872C12.9317 14.1872 12.6761 14.0896 12.4805 13.8944L2.10566 3.5196C1.71486 3.1292 1.71486 2.496 2.10566 2.1056C2.49646 1.7148 3.12926 1.7148 3.51966 2.1056L13.8949 12.4804C14.2857 12.8708 14.2857 13.504 13.8949 13.8944C13.6997 14.0896 13.4437 14.1872 13.1877 14.1872Z",
    fill: "#EF4452"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.8124 14.1872C2.5564 14.1872 2.3008 14.0896 2.1052 13.8944C1.7144 13.504 1.7144 12.8708 2.1052 12.4804L12.4804 2.1056C12.8712 1.7148 13.504 1.7148 13.8944 2.1056C14.2852 2.496 14.2852 3.1292 13.8944 3.5196L3.5192 13.8944C3.324 14.0896 3.0684 14.1872 2.8124 14.1872Z",
    fill: "#EF4452"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_516_1944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyTestX);
export default __webpack_public_path__ + "static/media/daily_test_x.b895251be5ddee5bccf22609da55dddd.svg";
export { ForwardRef as ReactComponent };